import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GoodBase  {
    _originalTypeClassName = "zERP.BO.GoodBase";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GoodBase.translate = translateService;
}
this.Stock = [];
this.Entity = new Domain.BusinessEntity();
this.Classifications = [];
this.IncomeBudgetItems = [];
this.ExpenseBudgetItems = [];
this.Id = null;
this.IsActive = false;
this.Name = null;
this.Code = null;
this.Description = null;
this.Fullname = null;
this.TransactionItemType = null;
this.HasWithheldTax = false;
this.HasFeesTax = false;
this.HasOtherTax = false;
this.HasStampDuty = false;
this.HasDeductions = false;
this.ExcludedFromBudget = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
IsActive:any;
Name:any;
Code:any;
Description:any;
Fullname:any;
TransactionItemType:any;
HasWithheldTax:any;
HasFeesTax:any;
HasOtherTax:any;
HasStampDuty:any;
HasDeductions:any;
ExcludedFromBudget:any;
Stock:any;
Entity:any;
Classifications:any;
WithheldPercentCategory:any;
StampDutyPercentCategory:any;
FeesPercentCategory:any;
OtherTaxesPercentCategory:any;
DeductionsPercentCategory:any;
VATCategory:any;
VATExemptionCategory:any;
AccountingConfig:any;
IncomeBudgetItems:any;
ExpenseBudgetItems:any;
static setStock = ($this, items) => {
                if (items == null) items = [];
                if ($this.Stock == null) $this.Stock = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Stock.length > 0) {
                    Domain.GoodBase.removeStock($this, $this.Stock[0]);
                }

                Domain.GoodBase.addManyStock($this, copyItems);
            }
static addManyStock = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GoodBase.addStock($this, items[i]);
                }
            }
static addStock = ($this, item) => {
                if ($this.Stock == null) $this.Stock = [];
                if (item == null || $this.Stock.indexOf(item) > -1) return;
                $this.Stock.push(item);
if (item.Good != $this) {
Domain.GoodStock.setGood(item, $this);
}
}
static addRangeStock = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GoodBase.addStock($this, item));
            }
static removeStock = ($this, item) => {
                if ($this == null || $this.Stock == null || $this.Stock.indexOf(item) === -1) return;
                var _index = $this.Stock.indexOf(item);
                $this.Stock.splice(_index, 1);
item.Good = null;
}
static clearStock = ($this) => { $this.Stock = null; }
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setClassifications = ($this, items) => {
                if (items == null) items = [];
                if ($this.Classifications == null) $this.Classifications = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Classifications.length > 0) {
                    Domain.GoodBase.removeClassifications($this, $this.Classifications[0]);
                }

                Domain.GoodBase.addManyClassifications($this, copyItems);
            }
static addManyClassifications = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GoodBase.addClassifications($this, items[i]);
                }
            }
static addClassifications = ($this, item) => {
                if ($this.Classifications == null) $this.Classifications = [];
                if (item == null || $this.Classifications.indexOf(item) > -1) return;
                $this.Classifications.push(item);
}
static addRangeClassifications = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GoodBase.addClassifications($this, item));
            }
static removeClassifications = ($this, item) => {
                if ($this == null || $this.Classifications == null || $this.Classifications.indexOf(item) === -1) return;
                var _index = $this.Classifications.indexOf(item);
                $this.Classifications.splice(_index, 1);
}
static clearClassifications = ($this) => { $this.Classifications = null; }
static setWithheldPercentCategory = ($this, value) => {
var oldValue = $this.WithheldPercentCategory;
$this.WithheldPercentCategory = value;
if (value != null) {
}
}
static setStampDutyPercentCategory = ($this, value) => {
var oldValue = $this.StampDutyPercentCategory;
$this.StampDutyPercentCategory = value;
if (value != null) {
}
}
static setFeesPercentCategory = ($this, value) => {
var oldValue = $this.FeesPercentCategory;
$this.FeesPercentCategory = value;
if (value != null) {
}
}
static setOtherTaxesPercentCategory = ($this, value) => {
var oldValue = $this.OtherTaxesPercentCategory;
$this.OtherTaxesPercentCategory = value;
if (value != null) {
}
}
static setDeductionsPercentCategory = ($this, value) => {
var oldValue = $this.DeductionsPercentCategory;
$this.DeductionsPercentCategory = value;
if (value != null) {
}
}
static setVATCategory = ($this, value) => {
var oldValue = $this.VATCategory;
$this.VATCategory = value;
if (value != null) {
}
}
static setVATExemptionCategory = ($this, value) => {
var oldValue = $this.VATExemptionCategory;
$this.VATExemptionCategory = value;
if (value != null) {
}
}
static setAccountingConfig = ($this, value) => {
var oldValue = $this.AccountingConfig;
$this.AccountingConfig = value;
if (value != null) {
}
}
static setIncomeBudgetItems = ($this, items) => {
                if (items == null) items = [];
                if ($this.IncomeBudgetItems == null) $this.IncomeBudgetItems = [];

                const copyItems = Common.cloneObject(items);

                while ($this.IncomeBudgetItems.length > 0) {
                    Domain.GoodBase.removeIncomeBudgetItems($this, $this.IncomeBudgetItems[0]);
                }

                Domain.GoodBase.addManyIncomeBudgetItems($this, copyItems);
            }
static addManyIncomeBudgetItems = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GoodBase.addIncomeBudgetItems($this, items[i]);
                }
            }
static addIncomeBudgetItems = ($this, item) => {
                if ($this.IncomeBudgetItems == null) $this.IncomeBudgetItems = [];
                if (item == null || $this.IncomeBudgetItems.indexOf(item) > -1) return;
                $this.IncomeBudgetItems.push(item);
}
static addRangeIncomeBudgetItems = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GoodBase.addIncomeBudgetItems($this, item));
            }
static removeIncomeBudgetItems = ($this, item) => {
                if ($this == null || $this.IncomeBudgetItems == null || $this.IncomeBudgetItems.indexOf(item) === -1) return;
                var _index = $this.IncomeBudgetItems.indexOf(item);
                $this.IncomeBudgetItems.splice(_index, 1);
}
static clearIncomeBudgetItems = ($this) => { $this.IncomeBudgetItems = null; }
static setExpenseBudgetItems = ($this, items) => {
                if (items == null) items = [];
                if ($this.ExpenseBudgetItems == null) $this.ExpenseBudgetItems = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ExpenseBudgetItems.length > 0) {
                    Domain.GoodBase.removeExpenseBudgetItems($this, $this.ExpenseBudgetItems[0]);
                }

                Domain.GoodBase.addManyExpenseBudgetItems($this, copyItems);
            }
static addManyExpenseBudgetItems = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GoodBase.addExpenseBudgetItems($this, items[i]);
                }
            }
static addExpenseBudgetItems = ($this, item) => {
                if ($this.ExpenseBudgetItems == null) $this.ExpenseBudgetItems = [];
                if (item == null || $this.ExpenseBudgetItems.indexOf(item) > -1) return;
                $this.ExpenseBudgetItems.push(item);
}
static addRangeExpenseBudgetItems = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GoodBase.addExpenseBudgetItems($this, item));
            }
static removeExpenseBudgetItems = ($this, item) => {
                if ($this == null || $this.ExpenseBudgetItems == null || $this.ExpenseBudgetItems.indexOf(item) === -1) return;
                var _index = $this.ExpenseBudgetItems.indexOf(item);
                $this.ExpenseBudgetItems.splice(_index, 1);
}
static clearExpenseBudgetItems = ($this) => { $this.ExpenseBudgetItems = null; }

static CheckIfCanBeAppliedOnAccounting(instance: any,avFor: any): any{let typeOfInstance = CLMS.Framework.Utilities.ThrowException("StdLib.RuntimeType.Name()").Test;
if (typeOfInstance == "Asset") {return avFor?.linq?.select((a) => a?.SystemName)?.toArray()?.linq?.contains("IsAsset");}
if (typeOfInstance == "Good") {return avFor?.linq?.select((a) => a?.SystemName)?.toArray()?.linq?.contains("IsGood");}
if (typeOfInstance == "Service") {return avFor?.linq?.select((a) => a?.SystemName)?.toArray()?.linq?.contains("IsService");}
if (typeOfInstance == "OtherTransactionItem") {return avFor?.linq?.select((a) => a?.SystemName)?.toArray()?.linq?.contains("IsOther");}
return false;
}
static GetClassName(): any{return CLMS.Framework.Utilities.ThrowException("StdLib.RuntimeType.Name()").Test;
}
static GetFullname($this: any): any{return $this?.Code + " - " + $this?.Name;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}